import { createSlice } from "@reduxjs/toolkit";
import { buscarContaRecorrenteModel } from "../../../models/contaRecorrente/buscarContaRecorrenteModel";
import { ContaRecorrenteModel } from "../../../models/contaRecorrente/contaRecorrenteModel";
import { RecorrenciaModel } from "../../../models/contaRecorrente/recorrenciaModel";
import { buscarContaRecorrente, buscarDetalheContaRecorrente, gerarRecorrencia, listarContaRecorrenteAtivos } from "../../../services/contaRecorrenteService";
import { resetAll } from "../../actions/actions";

export interface ContaRecorrenteState {
  //buscar conta recorrente
  loading: boolean;
  busca: buscarContaRecorrenteModel;
  list: ContaRecorrenteModel[];
  entity: ContaRecorrenteModel;
  //gerar recorrencia / busca detalhe conta recorrente
  loadingRecorrencia: boolean;
  listRecorrencia: RecorrenciaModel[];
  //internal
  page: string;
  modalAssociados: boolean;
  modalDeletar: boolean;
}

const initialState: ContaRecorrenteState = {
  //buscar conta recorrente
  loading: false,
  busca: { pesquisar: null, dataVigencia: null } as buscarContaRecorrenteModel,
  list: [],
  entity: {} as ContaRecorrenteModel,
  //gerar recorrencia / busca detalhe conta recorrente
  loadingRecorrencia: false,
  listRecorrencia: [],
  //internal
  page: "geral",
  modalAssociados: false,
  modalDeletar: false,
};

export const contaRecorrenteSlice = createSlice({
  name: "contaRecorrente",
  initialState,
  reducers: {
    //buscar conta recorrente
    setBuscaContaRecorrente: (state, action) => {
      state.busca = action.payload;
    },
    setEntityContaRecorrente: (state, action) => {
      state.entity = action.payload;
    },
    //gerar recorrencia / busca detalhe conta recorrente
    setListaRecorrenciaContaRecorrente: (state, action) => {
      state.listRecorrencia = action.payload;
    },
    //internal
    setPageContaRecorrente: (state, action) => {
      state.page = action.payload;
    },
    setModalAssociadosContaRecorrente: (state, action) => {
      state.modalAssociados = action.payload;
    },
    setModalDeletarContaRecorrente: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar conta recorrente
    builder.addCase(buscarContaRecorrente.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarContaRecorrente.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarContaRecorrente.rejected, (state, action) => {
      state.loading = false;
    });

    //gerar recorrencia
    builder.addCase(gerarRecorrencia.pending, (state) => {
      state.loadingRecorrencia = true;
    });
    builder.addCase(gerarRecorrencia.fulfilled, (state, action) => {
      state.listRecorrencia = action.payload;
      state.loadingRecorrencia = false;
    });
    builder.addCase(gerarRecorrencia.rejected, (state, action) => {
      state.loadingRecorrencia = false;
    });

    //busca detalhe conta recorrente
    builder.addCase(buscarDetalheContaRecorrente.pending, (state) => {
      state.loadingRecorrencia = true;
    });
    builder.addCase(buscarDetalheContaRecorrente.fulfilled, (state, action) => {
      state.listRecorrencia = action.payload;
      state.loadingRecorrencia = false;
    });
    builder.addCase(buscarDetalheContaRecorrente.rejected, (state, action) => {
      state.loadingRecorrencia = false;
    });

    //listar ativos
    builder.addCase(listarContaRecorrenteAtivos.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(listarContaRecorrenteAtivos.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(listarContaRecorrenteAtivos.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar conta recorrente
  setBuscaContaRecorrente,
  setEntityContaRecorrente,
  //gerar recorrencia / busca detalhe conta recorrente
  setListaRecorrenciaContaRecorrente,
  //internal
  setPageContaRecorrente,
  setModalAssociadosContaRecorrente,
  setModalDeletarContaRecorrente,
} = contaRecorrenteSlice.actions;

export default contaRecorrenteSlice.reducer;
